import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-toggle-type',
  template: `
    <div class="toggle-wrapper">
      <label class="toggle-label">{{ to.label }}</label>
      <mat-slide-toggle
		class="togControl"
       [formControl]="control"
        (change)="onToggleChange($event.checked)">
      </mat-slide-toggle>
    </div>
  `,
  styles: [`
    .toggle-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 4px 0;
      font-family: 'Poppins', sans-serif !important;
     .togControl .mat-slide-toggle-label .mat-slide-toggle-bar .mat-slide-toggle-thumb-container .mat-slide-toggle-thumb {
        background-color: #fff !important;
      }

     .togControl.mat-checked .mat-slide-toggle-label .mat-slide-toggle-bar {
        background-color: #8FC93A !important;
      }

    }

    .toggle-label {
      font-size: 12px;
      font-weight: 600;
      color: #101D42;
    }

    mat-slide-toggle {
      margin-left: 8px;
    }
  `]
})
export class ToggleTypeComponent extends FieldType implements OnInit {
   get control(): FormControl {
    return this.formControl as FormControl;
  }

  ngOnInit() {
    // Listen for form control changes and trigger external update if needed
    this.formControl.valueChanges.subscribe(value => {
      if (this.to['onChange']) {
        this.to['onChange'](value, this.field);
      }
    });
  }

  onToggleChange(checked: boolean) {
    // Update model explicitly (in case of manual binding)
    this.formControl.setValue(checked);
    if (this.to['onChange']) {
      this.to['onChange'](checked, this.field);
    }
  }
}
